module.exports = __webpack_public_path__ + "static/media/a-small.ae903afa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/planets/a-small.png
// module id = 1868
// module chunks = 0